import React, { useMemo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import HourglassIcon from '@mui/icons-material/HourglassEmpty';
import ErrorIcon from '@mui/icons-material/Error';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  button: {
    borderRadius: 0,
    height: 50,
  },
  icon: {
    width: 26,
    height: 26,
  },
}));
const PrimaryButton = ({ error, loading, icon, label, ...props }) => {
  const styles = useStyles({ error });

  return (
    <Button
      {...props}
      fullWidth
      startIcon={useMemo(
        () => {
          if (loading) {
            return <HourglassIcon className={styles.icon} />;
          }
          if (error) {
            return <ErrorIcon className={styles.icon} />;
          }
          return React.cloneElement(icon, { className: styles.icon });
        },
        [error, icon, loading, styles.icon],
      )}
      className={styles.button}
    >
      {useMemo(
        () => (loading
          ? 'One Moment...'
          : (error || label)),
        [
          error,
          label,
          loading,
        ],
      )}
    </Button>
  );
};

PrimaryButton.propTypes = {
  error: PropTypes.string,
  loading: PropTypes.bool,
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};

export default PrimaryButton;
